var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00006 10C8.2092 10 10.0001 8.20914 10.0001 6C10.0001 3.79086 8.2092 2 6.00006 2C3.79092 2 2.00006 3.79086 2.00006 6C2.00006 8.20914 3.79092 10 6.00006 10ZM11.0001 6C11.0001 8.76142 8.76148 11 6.00006 11C3.23864 11 1.00006 8.76142 1.00006 6C1.00006 3.23857 3.23864 0.999999 6.00006 0.999999C8.76148 0.999999 11.0001 3.23857 11.0001 6ZM6.00006 8.5C5.72392 8.5 5.50006 8.27614 5.50006 8L5.50006 6C5.50006 5.72386 5.72392 5.5 6.00006 5.5C6.2762 5.5 6.50006 5.72386 6.50006 6L6.50006 8C6.50006 8.27614 6.2762 8.5 6.00006 8.5ZM6.50006 4C6.50006 4.27614 6.2762 4.5 6.00006 4.5H5.99506C5.71892 4.5 5.49506 4.27614 5.49506 4C5.49506 3.72386 5.71892 3.5 5.99506 3.5H6.00006C6.2762 3.5 6.50006 3.72386 6.50006 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.e4af30a6f0d36ac716904a64c0d16888.svg";
export { ForwardRef as ReactComponent };